import flat from './flat'
import { confirmUrl } from './const'
import { request } from '@/utils'

/**
 * 获取用户地址列表
 */
export function getAddressList() {
  return flat(`${confirmUrl}/get_user_address`)
}

/**
 * 新建或者修改地址
 * @param {address.AddressItem} param
 */
export function updateAddress(param) {
  const { id } = param
  const url = id ? 'update_address' : 'create_address'
  return flat(`${confirmUrl}/${url}`, {
    method: 'POST',
    body: {
      ...param,
    },
  })
}

///api/mall/proxy/order/remove_address

/**
 * 新建或者修改地址
 * @param {number} id
 */
export function delAddress(id) {
  return flat(`${confirmUrl}/remove_address?id=${id}`)
}

/**
 * 选择地址
 * @param {number} id
 * @returns
 */
export function chooseAddress(id) {
  //choice_address
  return flat(`${confirmUrl}/choice_address?id=${id}`)
}

export function getChildAddress(id) {
  ///api/mall/proxy/order/get_child_address
  return flat(`${confirmUrl}/get_child_address?id=${id}`)
}

/**
 * 批量
 * @param {Array<number>} ids
 * @returns
 */
export function batchGetAddress(ids) {
  if (!Array.isArray(ids) || ids.length === 0) Promise.resolve({ data: {} })
  const u = `${confirmUrl}/get_child_address?id=`
  const arr = ids.map(id => {
    return new Promise((resolve, reject) => {
      request(`${u}${id}`)
        .then(data => {
          resolve({
            [id]: data,
          })
        })
        .catch(e => {
          reject(e)
        })
    })
  })
  return new Promise(resolve => {
    Promise.all(arr)
      .then(data => {
        let d = {}
        for (let i = 0, len = data.length; i < len; i++) {
          const _d = data[i]
          d = {
            ...d,
            ..._d,
          }
        }
        resolve({
          data: d,
        })
      })
      .catch(e => {
        resolve({
          error: e,
        })
      })
  })
}
